import React from "react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import SidebarUnauth from "../../Components/Sidebar/left-sidebar-unauth";
import { isBrowser, isMobile } from "react-device-detect";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import Logo from "../../Components/Logo/logo-svg";

export interface MinifiedDashboardProps {
  children?: React.ReactNode;
  platformId?: number;
  mobileMode?: () => void;
}

const UnAuthDashboard: React.FC<MinifiedDashboardProps> = ({ children, platformId, mobileMode }) => {
  return (
    <>
      {isMobile && (
        <Box display="flex" width="100%">
          <IconButton sx={{ height: "38px" }} onClick={() => mobileMode && mobileMode()}>
            <MenuOutlinedIcon />
          </IconButton>
          <Stack
            width={"100%"}
            height={"38px"}
            //   flexDirection={"row"}
            direction="row"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h6" mt={0.5}>
              Powered by
            </Typography>
            <Logo small={false} color="text.primary" />
          </Stack>
        </Box>
      )}
      <Box display="flex" minHeight="100vh">
        {isBrowser && <SidebarUnauth minified open={false} onUpdate={() => {}} platformId={platformId} />}
        <Stack direction="row" flex={1} position="relative">
          {children}
        </Stack>
      </Box>
    </>
  );
};

export default UnAuthDashboard;
